import { useMutation } from "@tanstack/react-query";
import { useSession } from "@hooks/useSession";
import axios from "@api/axios";

const usePostJsonData = () => {
  const { token } = useSession();
  const language = localStorage.getItem("ln") || "en"; // <-- Language fallback

  const mutationFn = async ({ url, data }) => {
    const response = await axios.post(url, data, {
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Accept-Language": language, // <-- Inject Accept-Language
      },
    });
    return response.data;
  };

  return useMutation({
    mutationFn,
    onError: (error) => {
      console.error("Error posting JSON data:", error);
    },
  });
};

export default usePostJsonData;
